import React, { useEffect } from "react";

import Header from 'components/Dashboard/Header'

import {
    DashboardPage,
    DashboardBody,
    DashboardBodyContent,
    Content
} from "./styled";
import { ReadObject } from "services/storage";
import { useHistory } from "react-router-dom";

export default function ContainerAuthenticated({ children, primary, page }){

    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);

    // NOTA: No modelo freemium, todo usuário logado tem acesso ao app.
    // - Usuários gratuitos: limitados a 20 mensagens/dia (controle no useFreeMessageLimit)
    // - Usuários Premium: mensagens ilimitadas
    // - Premium que cancela: continua ilimitado até o fim do período pago, depois "rebaixa" para gratuito
    // O modal de "assinatura expirada" foi removido pois bloqueava usuários gratuitos sem motivo.

    const init = () => {
        const authentication = ReadObject('authentication')
        if (!authentication?.jwt) {
            completeNext()
        }
    }

    const completeNext = () => {
        navigate('login')
    }

    useEffect(() => {
        init()
    }, [])

    return (
        <>
            <Content>
                <DashboardPage>
                    <Header page={page} />
                    <DashboardBody>
                        <DashboardBodyContent primary={primary}>
                            { children }
                        </DashboardBodyContent>
                    </DashboardBody>
                </DashboardPage>
            </Content>
        </>
    );
}